import React from "react";
import { ReactComponent as TulipAppIcon } from "../../assets/svgs/TulipAppIcon.svg";
import { ReactComponent as FloIcon } from "../../assets/svgs/FloIcon.svg";

const AppBox = ({ app }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: app.top,
        left: app.left,
        display: "flex",
        alignItems: "center"
      }}
    >
      <FloIcon
        style={{
          height: "25px",
          width: "25px",
        }}
      />
      <span style={{
        fontSize: "12px",
        color:"#194F91",
        letterSpacing:"0.25em",
        fontWeight:"600"
      }}>{app.name}</span>
      <TulipAppIcon
        style={{
          height: "25px",
          width: "25px",
        }}
      />
    </div>
  );
};

export default AppBox;
